import {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useState,
} from 'react'

const STORAGE_KEY = 'nabu.dashboard.sideNavExpanded'

function readStoredExpanded(): boolean {
  if (typeof window === 'undefined') {
    return true
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw === null) {
      return true
    }
    const parsed: unknown = JSON.parse(raw)
    return typeof parsed === 'boolean' ? parsed : true
  } catch {
    return true
  }
}

function writeStoredExpanded(value: boolean) {
  if (typeof window === 'undefined') {
    return
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // ignore quota / private mode
  }
}

export function usePersistedSideNavExpanded(): [
  boolean,
  Dispatch<SetStateAction<boolean>>
] {
  const [sideNavExpanded, setSideNavExpandedState] = useState(() =>
    readStoredExpanded()
  )

  const setSideNavExpanded = useCallback(
    (value: SetStateAction<boolean>) => {
      setSideNavExpandedState((prev) => {
        const next = typeof value === 'function' ? value(prev) : value
        writeStoredExpanded(next)
        return next
      })
    },
    []
  )

  return [sideNavExpanded, setSideNavExpanded]
}
